



































































import Vue from "vue";

export default Vue.extend({
  data() {
    return {
      hover: false
    };
  },
  methods: {
    status() {
      if (this.cute > 200 && this.cool > 200) {
        if (this.cute > this.cool) {
          return "Cute";
        } else {
          return "Cool";
        }
      } else if (this.cute > 200 && this.cool < 200) {
        return "Cute";
      } else if (this.cute < 200 && this.cool > 200) {
        return "Cool";
      } else {
        return "";
      }
    },
  },
  props: {
    name: String,
    honk: Number,
    wingspan: Number,
    neck: Number,
    cute: Number,
    cool: Number,
    sprite: String,
    fertile: Boolean,
    selected: Boolean
  }
})
